export default __webpack_public_path__ + "static/media/img_base_lemon_p.48314330.jpg";